import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Divider,
  Box,
  Button,
} from "@mui/material";

const LogoutModal = ({
  logoutModal,
  setLogoutModal,
  LogoutCurrentDevice,
  LogoutAllDevice,
  DeviceCount,
}) => {
  return (
    <Dialog
      open={logoutModal}
      onClose={() => setLogoutModal(false)}
      PaperProps={{
        sx: {
          borderRadius: 3,
          width: "90%",
          maxWidth: 380,
          textAlign: "center",
          p: 2,
        },
      }}
    >
      <DialogContent>
        <Typography
          variant="h6"
          fontWeight={700}
          mb={1.5}
          sx={{ color: "#1E293B" }}
        >
          Log out from?
        </Typography>

        <Divider />

        <Box
          onClick={LogoutCurrentDevice}
          sx={{
            py: 1.5,
            cursor: "pointer",
            "&:hover": { backgroundColor: "#FFF5F5" },
          }}
        >
          <Typography
            variant="subtitle2"
            fontWeight={700}
            sx={{ color: "#F33051" }}
          >
            Current Device
          </Typography>
        </Box>

        <Divider />

        <Box
          onClick={LogoutAllDevice}
          sx={{
            py: 1.5,
            cursor: "pointer",
            "&:hover": { backgroundColor: "#FFF5F5" },
          }}
        >
          <Typography
            variant="subtitle2"
            fontWeight={700}
            sx={{ color: "#F33051" }}
          >
            All Devices ({DeviceCount?.() || 0})
          </Typography>
        </Box>

        <Divider />

        <Box
          onClick={(e) => setLogoutModal(false)}
          sx={{
            py: 1.5,
            cursor: "pointer",
            "&:hover": { backgroundColor: "#F8FAFC" },
          }}
        >
          <Typography
            variant="subtitle2"
            fontWeight={700}
            sx={{ color: "#64748B" }}
          >
            Cancel
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LogoutModal;
